import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const yearOptions = [
  {
    title: "Fall",
    value: "Aug - Dec (Fall)",
  },
  {
    title: "Spring",
    value: "Jan - May (Spring)",
  },
  {
    title: "Summer",
    value: "May - Aug (Summer)",
  },
];

export const Intake = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex
      vertical
      justify="flex-start"
      align="flex-start"
      style={{ marginTop: "24px" }}
    >
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>Start term</Title>
      <TitleCardsList
        options={yearOptions}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
      />
    </Flex>
  );
};
